import { QuestionType } from "../enums/question-type.enum";

export interface Question {
  question: string;
  type: QuestionType;
}

export abstract class BasicQuestion implements Question {
  question: string;
  type: QuestionType;
  constructor(question: string, type: QuestionType) {
    this.question = question;
    this.type = type;
  }

  toJSON() {
    return {
      question: this.question,
      type: this.type
    };
  }
  get typeAsString(): string {
    return QuestionType[this.type];
  }
}

export class ShortAnswerQuestion extends BasicQuestion {
  constructor(question: string) {
    super(question, QuestionType.ShortAnswer);
  }

  toJSON = () => super.toJSON();
}

export abstract class SelectQuestion extends BasicQuestion {
  options: string[];
  constructor(question: string, options: string[], type: QuestionType) {
    super(question, type);
    this.options = options;
  }

  toJSON() {
    return {
      question: this.question,
      type: this.type,
      options: this.options
    };
  }
}

export class SelectOneQuestion extends SelectQuestion {
  constructor(question: string, options: string[]) {
    super(question, options, QuestionType.SelectOne);
  }
}

export class SelectManyQuestion extends SelectQuestion {
  constructor(question: string, options: string[]) {
    super(question, options, QuestionType.SelectMany);
    console.log(this.type);
  }
}

export class SelectManyWithLimitQuestion extends SelectQuestion {
  limit: number;
  constructor(question: string, options: string[], limit: number) {
    super(question, options, QuestionType.SelectManyWithLimit);
    this.limit = limit;
  }

  toJSON() {
    return {
      question: this.question,
      type: this.type,
      options: this.options,
      limit: this.limit
    };
  }
}
